import { ProductType } from '../../context';

export type LinkConfiguration = {
    type: string;
    label?: string;
    url?: string;
};

export type FooterConfiguration = {
    links: LinkConfiguration[];
};

export enum FooterLinkType {
    LegalTerms = 'legal-terms',
    PrivacyPolicy = 'privacy-policy',
    TermsOfUse = 'terms-of-use',
}

export type ExpertChatConfiguration = {
    enabled: boolean;
    key?: string;
};

export type AccountNavConfiguration = {
    enabled: boolean;
    links?: LinkConfiguration[];
};

export type LogoConfiguration = {
    url: string;
    alt: string;
};

export type SubNavConfiguration = {
    logo: LogoConfiguration;
};

export type WaffleMenuConfiguration = {
    enabled: boolean;
};

export type HeaderConfiguration = {
    accountNav: AccountNavConfiguration;
    logo: LogoConfiguration;
    waffleMenu: WaffleMenuConfiguration;
    subNav?: SubNavConfiguration;
};

export type I18nConfiguration = {
    defaultLocale: string;
    supportedLocales: string[];
};

export type LeftNavConfiguration = {
    enabled: boolean;
    links?: LinkConfiguration[];
    displayPartnerLogo?: boolean;
};

export type PartnerPickerConfiguration = {
    enabled: boolean;
    requireProductType?: boolean;
    defaultPath?: string;
    logoUrl?: string;
    order?: number;
};

export type PartnerProductConfiguration = {
    expertChat: ExpertChatConfiguration;
    header: HeaderConfiguration;
    i18n: I18nConfiguration;
    leftNav: LeftNavConfiguration;
    partnerPicker: PartnerPickerConfiguration;
    partnerDisplayName: string;
    productDisplayName?: string;
    footer: FooterConfiguration;
};

export type ProductConfigurations = {
    [ProductType.Default]: PartnerProductConfiguration;
} & Partial<Record<ProductType, Partial<PartnerProductConfiguration>>>;

export type PartnerProductConfigurations = Record<
    string,
    ProductConfigurations
>;
